import { useEffect } from 'react';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';
import { useMobileMenu } from '../MobileMenuContext';

export const Chat = () => {
	const { isMobileMenuOpen } = useMobileMenu();

	useEffect(() => {
		try {
			createChat({
				webhookUrl: 'https://n8n.srv859841.hstgr.cloud/webhook/7d2ecd50-140d-4b7d-a07b-42300ce295b0/chat',
		        webhookConfig: {
		        	method: 'POST',
		        	headers: {}
		        },
		        target: '#n8n-chat',
		        mode: 'window',
		        chatInputKey: 'chatInput',
		        chatSessionKey: 'sessionId',
		        loadPreviousSession: true,
		        metadata: {},
		        showWelcomeScreen: false,
		        defaultLanguage: 'en',
		        initialMessages: [
		        	'Hi there! 👋',
		        	'My name is Nathan. How can I assist you today?'
		        ],
		        i18n: {
		        	en: {
		        		title: 'Hi there! 👋',
		        		subtitle: "Start a chat. We're here to help you 24/7.",
		        		footer: '',
		        		getStarted: 'New Conversation',
		        		inputPlaceholder: 'Type your question..',
		        	},
		        },
		        enableStreaming: false,
			});
		} catch (error) {
			console.error('[Chat] Failed to initialize chat widget:', error);
			// Silently fail - chat widget is not critical for the app
		}
	}, []);

	useEffect(() => {
		// Find the n8n chat widget element and hide/show it based on mobile menu state
		const chatWidget = document.querySelector('#n8n-chat');
		if (chatWidget) {
			chatWidget.style.display = isMobileMenuOpen ? 'none' : 'block';
		}
	}, [isMobileMenuOpen]);

	return (<div id="n8n-chat"></div>);
};